export default __webpack_public_path__ + "static/media/plastic-calc-site.95f8ae84.jpeg";